import React from 'react';
import { Card, Row, Col, Select, Slider } from 'antd';

const { Option } = Select;

// Helper to get threshold color based on value
const getThresholdColor = (value) => {
  if (value >= 85) return '#52c41a'; // Green - strict, safer
  if (value >= 70) return '#1890ff'; // Blue - balanced
  return '#faad14'; // Orange - lenient, more detections
};

function BasicConfigSection({ config, updateConfig }) {
  const thresholdValue = config.confidence_threshold || 80;
  const thresholdColor = getThresholdColor(thresholdValue);

  return (
    <Card
      style={{ marginBottom: '24px', borderRadius: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}
      bodyStyle={{ padding: '20px' }}
    >
      <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '16px', color: '#262626', letterSpacing: '0.3px' }}>
        ⚙️ SCANNING CONFIGURATION
      </div>

      <Row gutter={16} style={{ marginBottom: '20px' }}>
        <Col span={12}>
          <label style={{ display: 'block', fontWeight: 600, marginBottom: '8px', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#8c8c8c' }}>
            Implementation Approach
          </label>
          <Select
            value={config.implementation_path || 'scanner'}
            onChange={(value) => updateConfig('implementation_path', value)}
            style={{ width: '100%' }}
            size="large"
          >
            <Option value="scanner">🔍 TrustGrid Scanner</Option>
            <Option value="instrumented">🔧 Instrumented App</Option>
            <Option value="hybrid">🔀 Hybrid</Option>
          </Select>
        </Col>
        <Col span={12}>
          <label style={{ display: 'block', fontWeight: 600, marginBottom: '8px', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#8c8c8c' }}>
            Scanning Mode
          </label>
          <Select
            value={config.pii_scanning_mode || 'none'}
            onChange={(value) => updateConfig('pii_scanning_mode', value)}
            style={{ width: '100%' }}
            size="large"
          >
            <Option value="none">None</Option>
            <Option value="realtime">⚡ Real-time</Option>
            <Option value="async">⏱️ Async</Option>
            <Option value="hybrid">🔀 Hybrid</Option>
          </Select>
        </Col>
      </Row>

      {/* Global Confidence Threshold */}
      <div style={{
        padding: '16px',
        backgroundColor: '#fafafa',
        borderRadius: '6px',
        border: `2px solid ${thresholdColor}`,
        transition: 'border-color 0.3s'
      }}>
        <label style={{
          display: 'block',
          fontWeight: 600,
          marginBottom: '12px',
          fontSize: '14px',
          color: thresholdColor,
          letterSpacing: '0.3px'
        }}>
          🎯 GLOBAL CONFIDENCE THRESHOLD: {thresholdValue}%
        </label>
        <Slider
          min={50}
          max={100}
          step={5}
          value={thresholdValue}
          onChange={(value) => updateConfig('confidence_threshold', value)}
          marks={{
            50: { label: <strong style={{ fontSize: '11px' }}>50%</strong> },
            70: { label: <span style={{ fontSize: '10px' }}>70%</span> },
            85: { label: <span style={{ fontSize: '10px' }}>85%</span> },
            100: { label: <strong style={{ fontSize: '11px' }}>100%</strong> }
          }}
          trackStyle={{ backgroundColor: thresholdColor, height: 6 }}
          handleStyle={{
            borderColor: thresholdColor,
            height: 20,
            width: 20,
            marginTop: -7,
            backgroundColor: '#fff',
            boxShadow: `0 2px 8px ${thresholdColor}80`
          }}
          railStyle={{ height: 6, backgroundColor: '#d9d9d9' }}
        />
        <div style={{ fontSize: '11px', color: '#595959', marginTop: '8px', display: 'flex', justifyContent: 'space-between' }}>
          <span>⚠️ More detections, may have false positives</span>
          <span>✅ Fewer false positives, more conservative</span>
        </div>
      </div>
    </Card>
  );
}

export default BasicConfigSection;
